<template>
  <v-app v-if="isLoading">
    <loading />
  </v-app>
  <v-card
    v-else
    class="EK-card mt-8 rounded-xl border-top border-right rounded-tr-0 EK-shadow IMTOrange"
  >
    <v-data-table
      dense
      :headers="headers"
      :items="areas"
      :search="searchText"
      :items-per-page="10"
      :page.sync="page"
      @page-count="pageCount = $event"
      hide-default-footer
    >
      <template v-slot:top>
        <v-text-field
          v-model="searchText"
          color="IMThemeGray"
          label="بحث في الجدول"
          style="width: 280px"
          append-icon="mdi-magnify"
          class="mx-4"
        ></v-text-field>
      </template>
      <template v-slot:item="{ item, index }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <tr
              v-on="on"
              v-bind="attrs"
              @click="goToDetails(areas.findIndex(area => area.id == item.id))"
              :class="{ active: id == (page-1)*10+index }"
            >
              <td>{{ item.name }}</td>
              <td>{{ item.cityName }}</td>
              <td>
                <v-btn @click="submitRemoveArea(index)" text>
                  <img src="/media/svg/table/delete.svg" alt="delete" />
                </v-btn>
              </td>
            </tr>
          </template>
          <span>انقر لعرض التفاصيل</span>
        </v-tooltip>
      </template>
    </v-data-table>
   <div class="w-100 pb-10 mt-10">
     
        <a-pagination 
        
       
       
        v-model="page"
        pageSize="10"
        :showTotal="(total) => `من أصل ${total} عنصر`"

        :total="areas.length"
        @showSizeChange="page"
       
        size="large" show-size-changer show-quick-jumper />
      </div>
  </v-card>
</template>
<style lang="scss" scoped>
.active {
  background: rgba(0, 0, 0, 0.125) !important;
}
td {
  user-select: none;
}
</style>
<script>
import { mapActions, mapGetters } from "vuex";
import aPagination from  'ant-design-vue/lib/pagination'

import loading from "@/components/loading";
import Swal from "sweetalert2";
export default {
  props: {
    id: String,
  },
  components: {
    loading,
    aPagination,
  },
  data: () => ({
    page: 1,
    pageCount: 0,
    searchText: "",
    headers: [
      {
        text: "المنطقة",
        value: "name",
        sortable: true,
      },
      {
        text: "المحافظة",
        value: "cityName",
        sortable: true,
      },
      {
        text: "حذف",
        value: "delete",
        sortable: false,
      },
    ],
  }),
  created() {
    this.fetchAreas();
  },
  computed: {
    ...mapGetters(["areas", "isLoading"]),
  },
  methods: {
    ...mapActions(["fetchAreas", "removeArea"]),
    goToDetails(id) {
      if (id != this.id) {
        this.$router.push(`${id}`);
      }
    },
    submitRemoveArea(item) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: true,
      });
      swalWithBootstrapButtons
        .fire({
          title: "هل أنت متأكد؟",
          text: "هل فعلاً تريد حذف المنطقة ؟",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "نعم!",
          cancelButtonText: "إلغاء",
          reverseButtons: false,
        })
        .then((result) => {
          if (result.value) {
            this.removeArea(item);
            if (this.id != -1) {
              this.$router.push("./-1");
            }
          }
        });
    },
  },
};
</script>
